import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { CommitmentDataSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportCommitmentData, sortCommitmentData } from '../../constants';
import { getCommitmentReport, getAllCommitmentReport } from '../../actions';
import { makeGetListCommitmentData, makeGetListAllListCommitmentData } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
class CommitmentData extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      groupBy: 'FALSE',
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listCommitmentData: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listCommitmentData: props.listCommitmentData,
      totalCount: getPageTotalCount({ ...state, items: props.listCommitmentData }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetCommitmentReport },
    } = this.props;
    if (modeGetCommitmentReport) {
      this.doGetListCommitmentData();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListCommitmentData();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListCommitmentData());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListCommitmentData());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListCommitmentData();
    });
  };

  doGetListCommitmentData = () => {
    const { filter, page, size, sorted } = this.state;
    const { getCommitmentReport } = this.props;
    const newFilter = cloneDeep(filter);
    // if (!newFilter.year) newFilter.year = moment().format('YYYY');
    if (!newFilter.commitmentTerm) newFilter.commitmentTerm = 'LATEST_TERM';
    if (!newFilter.serviceType) newFilter.serviceType = 'ALL';
    if (newFilter.groupBy) newFilter.groupBy = newFilter.groupBy === 'TRUE' ? 'true' : 'false';

    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortCommitmentData[sorted.sortCol]
          ? sortCommitmentData[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getCommitmentReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistCommitmentData = cb => {
    const { filter, sorted } = this.state;
    const { getAllCommitmentReport } = this.props;
    const newFilter = cloneDeep(filter);
    // if (!newFilter.year) newFilter.year = moment().format('YYYY');
    if (!newFilter.commitmentTerm) newFilter.commitmentTerm = 'LATEST_TERM';
    if (!newFilter.serviceType) newFilter.serviceType = 'ALL';
    if (newFilter.groupBy) newFilter.groupBy = newFilter.groupBy === 'TRUE' ? 'true' : 'false';

    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortCommitmentData[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllCommitmentReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistCommitmentData(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllCommitmentData, t } = this.props;
        convertJson2Pdf({
          data: listAllCommitmentData,
          t,
          title: t('reportPage:sidebar.commitmentData').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.commitmentData')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistCommitmentData(() => {
      const { listAllCommitmentData, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'COMMITMENT_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.commitmentData')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.commitmentData')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllCommitmentData,
            t,
            columns: tableColumnsOutput,
            // listOptionFields: { accountType: 'accountType', billType: 'billUnitType', paymentMethod: 'paymentMethod' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllCommitmentData,
          t,
          title: t('reportPage:sidebar.commitmentData').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.commitmentData')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.commitmentData')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('COMMITMENT_DATA_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportCommitmentData,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listCommitmentData,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllCommitmentData,
      t,
      permissions: { modeGetCommitmentReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetCommitmentReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.commitmentData') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.commitmentData')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <CommitmentDataSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.commitmentData').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllCommitmentData,
                          t,
                          title: t('reportPage:sidebar.commitmentData').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.commitmentData')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listCommitmentData}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listCommitmentData && listCommitmentData.length ? listCommitmentData : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

CommitmentData.propTypes = {
  getCommitmentReport: PropTypes.func,
  getAllCommitmentReport: PropTypes.func,
  listAllCommitmentData: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

CommitmentData.defaultProps = {
  getCommitmentReport: () => {},
  getAllCommitmentReport: () => {},
  listAllCommitmentData: [],
};

const mapStateToProps = createStructuredSelector({
  listCommitmentData: makeGetListCommitmentData() || [],
  listAllCommitmentData: makeGetListAllListCommitmentData() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getCommitmentReport,
    getAllCommitmentReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(CommitmentData)
);
